import { render, staticRenderFns } from "./BaseList.vue?vue&type=template&id=22176bb3&scoped=true&functional=true&"
import script from "./BaseList.vue?vue&type=script&lang=ts&"
export * from "./BaseList.vue?vue&type=script&lang=ts&"
import style0 from "./BaseList.vue?vue&type=style&index=0&id=22176bb3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "22176bb3",
  null
  
)

export default component.exports